import { useState } from "react";
import { colors, fonts, frames, mediaQueriesNumbers, useMediaQuery } from "../../../../../Styles";
import { AicoConnection, PageHeader, NewButton, AreaLayout, TableTypes, ConfirmModal } from "../../../../../Components";
import { useMutation } from "@apollo/client";
import { CLEAR_ALL_TABLES, ClearAllTablesArgs, ClearAllTablesResponse } from "../../../../../Services/Agrisys_GqlDataCaller/ServiceToolCalls/GQLCalls/clearAllTables";
import { useAicoConnection } from "../../../../../Components/ToolsComponents/_ToolsComponents/aicoConnectionContext";

export default function DataTableActions() {
	const mobileXs = useMediaQuery(`(max-width: ${mediaQueriesNumbers.mobileXs}px)`); 
	
	const [isClearAllTablesModalOpen, setIsClearAllTablesModalOpen] = useState<boolean>(false);

	const { state: connectionState } = useAicoConnection();

	// #region | Clear Tables
	const [fetchData, { data, loading, error, reset }] = useMutation<ClearAllTablesResponse, ClearAllTablesArgs>(CLEAR_ALL_TABLES, {
		fetchPolicy: "network-only"
	});

	async function handleCommit() {
		if (!connectionState.deviceConnection) {
			return;
		}

		fetchData({ variables: connectionState.deviceConnection });
	}
	// #endregion

	return (
		<frames.Page_inner>
				<PageHeader topHeader='Device Data' subHeader='Actions' />
			<frames._page_inner_content>
				<AreaLayout
					tableType={TableTypes.fitContent}
					headerArea={mobileXs ? undefined : <AicoConnection inTable/>}
					buttonArea={<div style={{ display: "flex", gap: "5px" }}>
						{mobileXs && <AicoConnection inTable/>}
					</div>
					}
					contentArea={<div style={{ display: "flex", flexDirection: "column", gap: "50px", height: "100%", alignItems: "center" }}>
						<NewButton
							content={"Clear All Tables"}
							disabled={!connectionState.deviceConnection}
							onClick={() => {
								setIsClearAllTablesModalOpen(true);
							}}
							overrides={{
								baseStyles: { width: "fit-content", backgroundColor: colors.greyTertiary, height: "30px", padding: "0 10px" },
								contentStyles: { color: colors.greyDarkPrimary, textShadow: "none", ...fonts.fontSize4 },
								hoverStyles: { backgroundColor: colors.greyLightPrimary, color: colors.greyDarkPrimary }
							}}
						/>
					</div>}
				/>
			</frames._page_inner_content>
			
			{connectionState.deviceConnection && isClearAllTablesModalOpen &&
				<ConfirmModal
					onCancel={() => { setIsClearAllTablesModalOpen(false); reset()}}
					onConfirm={() => handleCommit()}
					disclaimer="This action will clear all the tables on the LAN Controller, it will not contain any data, this action is irreversible!"
					message={
						(error || (data?.controller && !data.controller.clearAllTables?.success)) ? "ERROR: Failed to clear all tables" :
						(!loading && !error && data?.controller.clearAllTables?.success) ? "Succesfully cleared all tables" : undefined
					}
					loading={loading}
				/>
			}
		</frames.Page_inner>
	)
}

